function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "nriia",
  d: "M287.473 854.313l2.544 5.998 6.513.558c.451.039.635.6.292.896l-4.94 4.263 1.48 6.343a.512.512 0 0 1-.764.554L287 869.562l-5.598 3.363a.513.513 0 0 1-.764-.554l1.48-6.343-4.941-4.264a.51.51 0 0 1 .292-.896l6.513-.558 2.544-5.997a.514.514 0 0 1 .946 0z"
}), React.createElement("path", {
  id: "nriib",
  d: "M315.473 854.313l2.544 5.998 6.513.558c.451.039.635.6.292.896l-4.94 4.263 1.48 6.343a.512.512 0 0 1-.764.554L315 869.562l-5.598 3.363a.513.513 0 0 1-.764-.554l1.48-6.343-4.941-4.264a.51.51 0 0 1 .292-.896l6.513-.558 2.544-5.997a.514.514 0 0 1 .946 0z"
}), React.createElement("path", {
  id: "nriic",
  d: "M343.473 854.313l2.544 5.998 6.513.558c.451.039.635.6.292.896l-4.94 4.263 1.48 6.343a.512.512 0 0 1-.764.554L343 869.562l-5.598 3.363a.513.513 0 0 1-.764-.554l1.48-6.343-4.941-4.264a.51.51 0 0 1 .292-.896l6.513-.558 2.544-5.997a.514.514 0 0 1 .946 0z"
}), React.createElement("path", {
  id: "nriid",
  d: "M371.473 854.313l2.544 5.998 6.513.558c.451.039.635.6.292.896l-4.94 4.263 1.48 6.343a.512.512 0 0 1-.764.554L371 869.562l-5.598 3.363a.513.513 0 0 1-.764-.554l1.48-6.343-4.941-4.264a.51.51 0 0 1 .292-.896l6.513-.558 2.544-5.997a.514.514 0 0 1 .946 0z"
}), React.createElement("path", {
  id: "nriie",
  d: "M399.473 854.313l2.544 5.998 6.513.558c.451.039.635.6.292.896l-4.94 4.263 1.48 6.343a.512.512 0 0 1-.764.554L399 869.562l-5.598 3.363a.513.513 0 0 1-.764-.554l1.48-6.343-4.941-4.264a.51.51 0 0 1 .292-.896l6.513-.558 2.544-5.997a.514.514 0 0 1 .946 0z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(-277 -854)"
}, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#nriia"
})), React.createElement("g", {
  transform: "translate(-277 -854)"
}, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#nriib"
})), React.createElement("g", {
  transform: "translate(-277 -854)"
}, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#nriic"
})), React.createElement("g", {
  transform: "translate(-277 -854)"
}, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#nriid"
})), React.createElement("g", {
  transform: "translate(-277 -854)"
}, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#nriie"
})));

var SvgStars = function SvgStars(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 132,
    height: 19,
    viewBox: "0 0 132 19",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStars, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stars.23f176fa.svg";
export { ForwardRef as ReactComponent };